import React from 'react'

import { Group, Shape } from 'react-konva'
import _ from 'lodash'

import { normalizeAnnotationAbsCoordinates } from '../utils/annotationUtils'
import { useAppThemeColors } from '../../../../shared/hooks'

interface NewAnnotationMarkerProps {
  annotationInProgress: any
  currentZoom: number
  currentScale: number
}

// Функция для создания формы маркера
const renderShape = (context, shape) => {
  const width = shape.width()
  const radius = width / 2

  context.beginPath()
  context.arc(0, 0, radius, -Math.PI, -Math.PI - Math.PI / 2, false)
  context.lineTo(-radius, radius)
  context.closePath()
  context.fillStrokeShape(shape)
}

const getMarkerSize = (squareSize = 40, zoom: number) => {
  // Базовый размер для маркера
  let size = squareSize

  // Коррекция размера в зависимости от зума
  if (zoom > 200) {
    size = squareSize * 0.75
  } else if(zoom > 350) {
    size = squareSize * 0.5
  }
  return size
}

export const NewAnnotationMarker: React.FC<NewAnnotationMarkerProps> = ({
  annotationInProgress,
  currentZoom,
  currentScale
}) => {
  if (!annotationInProgress) return null
  const themeColors = useAppThemeColors()
  const strokeColor = themeColors.primary
  const { x, y, width, height } = normalizeAnnotationAbsCoordinates(annotationInProgress)

  const customShapeStrokeWidth = 2
  const customShapeStrokeColor = strokeColor
  const fillColor = strokeColor
  const squareSize = getMarkerSize(32, currentZoom)
  const xPos = x + width + squareSize + customShapeStrokeWidth + 2 - 16
  let yPos = y + height - squareSize / 2 - customShapeStrokeWidth / 2
  yPos = Math.max(yPos, 0)

  return (
    <Group
      key={`new-annotation-marker-${annotationInProgress.id}`}
      x={xPos}
      y={yPos}
      draggable={false}
    >
      {/* Размытая тень маркера - несколько слоев для эффекта размытия */}
      <Shape
        width={squareSize}
        height={squareSize}
        sceneFunc={renderShape}
        fill="rgba(0, 0, 0, 0.1)"
        stroke="rgba(0, 0, 0, 0.05)"
        strokeWidth={customShapeStrokeWidth}
        x={4}
        y={4}
        perfectDrawEnabled={true}
        listening={false}
        cached={true}
        pixelRatio={currentScale}
      />

      <Shape
        width={squareSize}
        height={squareSize}
        sceneFunc={renderShape}
        fill="rgba(0, 0, 0, 0.15)"
        stroke="rgba(0, 0, 0, 0.08)"
        strokeWidth={customShapeStrokeWidth}
        x={3}
        y={3}
        perfectDrawEnabled={true}
        listening={false}
        cached={true}
        pixelRatio={currentScale}
      />

      <Shape
        width={squareSize}
        height={squareSize}
        sceneFunc={renderShape}
        fill="rgba(0, 0, 0, 0.2)"
        stroke="rgba(0, 0, 0, 0.12)"
        strokeWidth={customShapeStrokeWidth}
        x={2}
        y={3}
        perfectDrawEnabled={true}
        listening={false}
        cached={true}
        pixelRatio={currentScale}
      />

      {/* Основной маркер */}
      <Shape
        width={squareSize}
        height={squareSize}
        sceneFunc={renderShape}
        fill={fillColor}
        stroke={customShapeStrokeColor}
        strokeWidth={customShapeStrokeWidth}
        perfectDrawEnabled={true}
        listening={false}
        cached={true}
        pixelRatio={currentScale}
      />
    </Group>
  )
}
